export const projectData = [
    {
        key: 3758,
        name: "Horno y Vuelco de Escoria + Colada Continua",
        client: "Sidersa S.A.",
        location: "Planta Sidersa. San Nicolás. Pcia. de Bs. As.",
        year: "2024",
        month: "Octubre",
        latitude: -33.39270503007502, 
        longitude: -60.21125545283398,
        description: "Proyecto de Horno Siderúrgico y línea de Colada Continua.",
        items: ["Caracterización geotécnica a partir de ensayos SPT y laboratorio","Ensayos DMT in situ","Ensayos triaxiales UU","Modelización numérica de interacción suelo-estructura (ISE)"],
        url: "/assets/projects/3758.jpeg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -33.39270503007502 + "%2C" + -60.21125545283398
    },
    {
        key: 3722,
        name: "Muelle de Minerales",
        client: "TERNIUM Argentina S.A.",
        location: "Planta TERNIUM Gral. Savio. San Nicolás. Pcia. de Buenos Aires.",
        year: "2024",
        month: "Agosto",
        latitude: -33.36080048023613,
        longitude: -60.1460766320246,
        description: "Verificación del perfil geotécnico bajo muelle.",
        items: ["Perforación bajo el lecho del río sobre plataforma flotante.","Caracterización del perfil geotécnico a partir de ensayos SPT y laboratorio", "Ensayos triaxiales UU"],
        url: "/assets/projects/3722.jpeg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -33.36080048023613 + "%2C" + -60.1460766320246
    },
    {
        key: 3756,
        name: "Emisario de Descarga al Río Gualeguaychú",
        client: "GINSA S.A.",
        location: "Gualeguaychú. Pcia. de Entre Ríos.",
        year: "2024",
        month: "Agosto",
        latitude: -33.032519765688335, 
        longitude: -58.50835569944506,
        description: "Proyecto de Emisario de Descarga al Río Gualeguaychú, como parte del Proyecto Integral de ciudades en la cuenca del Río Uruguay.",
        items: ["Perforación bajo el lecho del río sobre plataforma flotante","Caracterización geotécnica a partir de ensayos SPT y laboratorio"],
        url: "/assets/projects/3756.jpeg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -33.032519765688335 + "%2C" + -58.50835569944506
    },
    {
        key: 3745,
        name: "Acueducto Interprovincial Santa Fe-Córdoba. Obra de Toma",
        client: "Gezhouba - Ecosur Bahía S.A. - Acueducto Santa Fe Córdoba UT",
        location: "Coronda. Pcia. de Santa Fe",
        year: "2024",
        month: "Junio",
        latitude: -31.93867070283969, 
        longitude: -60.91086535112465,
        description: "Obra de toma para acueducto.",
        items: ["Perforación bajo el lecho del río sobre plataforma flotante.","Caracterización geotécnica a partir de ensayos SPT y laboratorio"],
        url: "/assets/projects/3745.png",
        link: "https://www.google.com/maps/search/?api=1&query=" + -31.93867070283969 + "%2C" + -60.91086535112465
    },
    {
        key: 3747,
        name: "Fundación de Grúa",
        client: "Club de Regatas San Nicolás",
        location: "San Nicolás. Pcia. de Buenos Aires.",
        year: "2024",
        month: "Junio",
        latitude: -33.32432998967115, 
        longitude: -60.21102540990766,
        description: "Verificación del perfil geotécnico bajo grúa existente y futuro refuerzo.",
        items: ["Perforación bajo el lecho del río.","Caracterización del perfil geotécnico a partir de ensayos SPT y laboratorio", "Ensayos triaxiales UU"],
        url: "/assets/projects/3747.jpeg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -33.32432998967115 + "%2C" + -60.21102540990766
    },
    {
        key: 3739,
        name: "Parque Eólico La Escondida. Estación Transformadora",
        client: "Luz de Tres Picos S.A.",
        location: "Vieytes. Pcia. de Buenos Aires.",
        year: "2024",
        month: "Mayo",
        latitude: -35.34500912357769, 
        longitude: -57.52688156892696,
        description: "Construcción de Estación Transformadora para Parque Eólico.",
        items: ["Caracterización del perfil geotécnico a partir de ensayos SPT y laboratorio","Extracción de muestras inalteradas mediante tomamuestras Shelby y Denison","Ensayos de expansión libre y presión de expansión","Ensayos triaxiales UU","Mediciones de resistividad eléctrica","Estimación de hinchamiento potencial y propuesta de reemplazo de suelos","Determinación de parámetros para el proyecto de fundaciones superficiales y profundas","Determinaciones químicas de agresividad"],
        url: "/assets/projects/3739.jpeg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -35.34500912357769 + "%2C" + -57.52688156892696
    },
    {
        key: 3729,
        name: "Terminal Puerto Timbúes",
        client: "Terminales y Servicios S.A.",
        location: "Timbúes. Pcia. de Santa Fe",
        year: "2024",
        month: "Marzo",
        latitude: -32.56754006387419,
        longitude: -60.80233138962793,
        description: "Construcción de un muelle para atraque, carga y descarga de buques de gran porte, como así también instalaciones de acopio y transporte de cargas en la zona superior de la barranca",
        items: ["Perforaciones con apoyo en tierra y sobre plataforma flotante bajo el lecho del río","Caracterización del perfil geotécnico a partir de ensayos SPT y laboratorio","Ensayos triaxiales UU","Mediciones de resistividad eléctrica","Ejecución de calicatas a cielo abierto","Análisis de sensibilidad a la cal","Ensayos Proctor y CBR","Determinación de parámetros para el proyecto de fundaciones superficiales y profundas","Determinación de parámetros para movimiento de suelos y proyecto de pavimentos"],
        url: "/assets/projects/3729.jpeg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -32.56754006387419+ "%2C" + -60.80233138962793
    },
    {
        key: 3732,
        name: "Revamping de Posta de Inflamables Nº1",
        client: "CONCRET-NOR S.A. DyOP S.A.",
        location: "Puerto Galván. Bahía Blanca. Pcia. de Buenos Aires.",
        year: "2024",
        month: "Enero-Febrero",
        latitude: -38.79688229463475, 
        longitude: -62.25864903534304,
        description: "Construcción de estructuras portuarias que se fundarán mediante pilotes excavados y hormigonados in situ bajo el fondo de la ría, que tendrán diámetros del orden de 1,60 m.",
        items: ["Caracterización del perfil geotécnico a partir de ensayos SPT y laboratorio sobre plataforma en voladizo","Determinación de parámetros para el proyecto de pilotes comprimidos y traccionados de gran diámetro"],
        url: "/assets/projects/3732.jpeg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -38.79688229463475 + "%2C" + -62.25864903534304
    },
    {
        key: 3728,
        name: "Parque Eólico La Escondida",
        client: "Luz de Tres Picos S.A.",
        location: "Vieytes. Pcia. de Buenos Aires",
        year: "2023",
        month: "Noviembre",
        latitude: -35.31840424706173, 
        longitude: -57.55087083469002,
        description: "Parque eólico en la provincia de Buenos Aires.",
        items: ["Caracterización geotécnica a partir de ensayos SPT y laboratorio","Ensayos triaxiales CU y UU sobre muestras inalteradas","Ensayos de consolidación unidimensional","Medición de la resistividad eléctrica del terreno (Wenner)","Medición de la resistividad térmica del terreno","Ensayos de carga con placa (PLT)","Modelización numérica y verificaciones de estabilidad y deformaciones para bases de aerogeneradores","Recomendaciones para movimiento de suelos y diseño de pavimentos","Caracterización de la agresividad química de suelos y agua subterránea"],
        url: "/assets/projects/3728.png",
        link: "https://www.google.com/maps/search/?api=1&query=" + -35.31840424706173 + "%2C" + -57.55087083469002
    },
    {
        key: 3725,
        name: "Ampliación Planta CT Genelba",
        client: "Pampa Energía S.A.",
        location: "Marcos Paz. Pcia. de Buenos Aires",
        year: "2023",
        month: "Noviembre",
        latitude: -34.89979379513897,
        longitude: -58.730172778858766,
        description: "Ampliación de Central Térmica Genelba",
        items: ["Caracterización geotécnica a partir de ensayos SPT y laboratorio","Ensayos triaxiales UU sobre muestras inalteradas","Caracterización dinámica del terreno mediante geofísica (DownHole)","Ensayos Proctor y CBR","Cálculo de capacidad portante y asentamientos para fundaciones superficiales","Cálculo de capacidad portante para pilotes perforados","Recomendaciones para diseño de estructuras de contención y excavaciones","Recomendaciones para movimiento de suelos y diseño de pavimentos","Caracterización de la agresividad química de suelos y agua subterránea"],
        url: "/assets/projects/3725.jpeg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -34.89979379513897 + "%2C" + -58.730172778858766
    },
    {
        key: 3721,
        name: "Celda 66",
        client: "Cargill S.A.C.I.",
        location: "Villa Gdor. Galvez. Pcia. de Santa Fe",
        year: "2023",
        month: "Septiembre",
        latitude: -33.038625825306944,
        longitude: -60.58440884007627,
        description: "Celda de acopio de 130 m. de largo x 45 m. de ancho",
        items: ["Caracterización geotécnica a partir de ensayos SPT y laboratorio","Análisis de estabilidad de taludes de excavación","Cálculo de capacidad de carga de pilotes perforados"],
        url: "/assets/projects/3721.jpg",
    },
    {
        key: 3714,
        name: "Muro Vuelco 3",
        client: "TERNIUM Argentina S.A.",
        location: "San Nicolás. Pcia. de Buenos Aires",
        year: "2023",
        month: "Julio-Agosto",
        latitude: -32.959214,
        longitude: -60.631360,
        description: "Recinto de excavación de 10 m. de profundidad en un área de 12 m. x 5 m.",
        items: ["Caracterización geotécnica a partir de ensayos SPT y laboratorio","Análisis de estabilidad de taludes de excavación","Modelación numérica de la interacción suelo-estructura"],
        url: "/assets/projects/3714.jpg",
    },
    {
        key: 3712,
        name: "Pensaer XVIII",
        client: "Pensaer S.A.",
        location: "Rosario. Pcia. de Santa Fe",
        year: "2023",
        month: "Junio-Julio",
        latitude: -32.959214,
        longitude: -60.631360,
        description: "Edificio de 11 pisos altos y medio nivel de subsuelos en un área de 8,60 m. x 29,80 m.",
        items: ["Caracterización geotécnica a partir de ensayos SPT y laboratorio","Cálculo de capacidad de carga de pilotes perforados","Recomendaciones para excavaciones"],
        url: "/assets/projects/3712.jpg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -27.697762 + "%2C" + -67.642410
    },
    {
        key: 3704,
        name: "Tanques de combustible",
        client: "Grupo Formas S.R.L. y Powerchina Ltd. U.T.E.",
        location: "Fiambalá. Pcia. de Catamarca",
        year: "2023",
        month: "Abril-Mayo",
        latitude: -27.697762,
        longitude: -67.642410,
        description: "Proyecto de dos tanques metálicos de combustible de 16 m. de diámetro y 9 m. de altura con sus correspondientes recintos de contención.",
        items: ["Caracterización geotécnica a partir de ensayos SPT y laboratorio","Cálculo de capacidad de carga","Estimación de asentamientos"],
        url: "/assets/projects/3704.jpeg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -27.697762 + "%2C" + -67.642410
    },
    {
        key: 3703,
        name: "Muelle de combustibles",
        client: "DyOP S.A. / Pilotes TREVI SACIMS / CONCRET-NOR S.A. UT",
        location: "Ría de Bahía Blanca. Puerto Rosales. Pcia. de Bs. As.",
        year: "2023",
        month: "Mayo-Septiembre",
        latitude: -38.933755329231246,
        longitude: -62.056074538418294,
        description: "Proyecto de muelle de combustibles en la ría de Bahía Blanca, además de un viaducto de acceso, una plataforma de servicio, una plataforma de operación, torres de amarre y dolfines de atraque. Todas las estructuras se fundarán mediante pilotes excavados y hormigonados in situ bajo el fondo de la ría, con diámetros de 0,60 m. a 1,60 m.",
        items: ["Caracterización geotécnica a partir de ensayos SPT y laboratorio","Caracterización geológica regional","Cálculo de capacidad de carga de pilotes perforados","Estimación de rigidez lateral del terreno para pilotes perforados"],
        url: "/assets/projects/3703.jpg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -38.933755329231246 + "%2C" + -62.056074538418294 
    },
    {
        key: 3701,
        name: "Parques Eólicos PEGL I y II",
        client: "José J. Chediack S.A.I.C.A.",
        location: "Gral. Levalle. Pcia. de Córdoba",
        year: "2023",
        month: "Abril-Julio",
        latitude: -34.031952996761156,
        longitude: -63.887809582443566,
        description: "Proyecto de 25 aerogeneradores en el sur de la provincia de Córdoba.",
        items: ["Caracterización geotécnica a partir de ensayos SPT y laboratorio","Ensayos triaxiales UU y de compresión simple","Mediciones de resistividad eléctrica (Wenner)","Agresividad química"],
        url: "/assets/projects/3701.jpg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -34.031952996761156 + "%2C" + -63.887809582443566
    },
    {
        key: 3687,
        name: "Expansión Planta Profertil",
        client: "Profertil S.A.",
        location: "Zona Cangrejales S/N. Planta Profertil. Ing. White. Pcia. de Bs. As.",
        year: "2022",
        month: "Diciembre 2022-Junio 2023",
        latitude: -38.78530653746233,
        longitude: -62.281806220457504,
        description: "Proyecto de ampliación Planta Profertil Ing. White",
        items: ["Caracterización geotécnica a partir de ensayos SPT y laboratorio","Extracción de muestras inalteradas mediante tomamuestras Shelby y Denison","Ejecución de ensayos CPTu y pruebas de disipación","Ejecución de calicatas a cielo abierto","Ejecución de ensayos de permeabilidad Lefranc","Prospección geofísica mediante ensayos Down-Hole","Ensayos de hinchamiento y colapso","Ensayos Proctor y CBR","Ensayos triaxiales CU","Ensayos de consolidación","Mediciones de resistividad eléctrica (Wenner)","Determinaciones de agresividad química"],
        url: "/assets/projects/3687.jpeg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -38.78530653746233 + "%2C" + -62.281806220457504
    },
    {
        key: 3654,
        name: "Nuevo Complejo de Laboratorios - BCR Labs",
        client: "Bolsa de Comercio de Rosario Asoc. Civil",
        location: "Av. Sorrento y Pcias. Unidas. Rosario",
        year: "2022",
        month: "Septiembre",
        latitude: -32.90886161728532, 
        longitude: -60.714208684575816,
        description: "Complejo de laboratorios y oficinas",
        items: ["Caracterización geotécnica a partir de ensayos SPT y laboratorio","Cálculo de capacidad portante para fundaciones superficiales, semiprofundas y profundas","Recomendaciones para movimiento de suelos y diseño de pavimentos","Caracterización de la agresividad química de suelos y agua subterránea"],
        url: "/assets/projects/3654.jpeg",
        link: "https://www.google.com/maps/search/?api=1&query=" + -32.90886161728532 + "%2C" + -60.714208684575816
    }
]